'use client';
import React, { Suspense, useMemo, useState } from 'react';
import { Chip } from '@material-tailwind/react';
import Image from 'next/image';
import videoTextCardColors from '../theme/videoTextCardColors';

function VideoTextCard({ data }) {
    const tabs = Object.keys(data);
    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    const randInt = useMemo(
        () => Math.floor(Math.random() * videoTextCardColors.length),
        [],
    );
    const theme = useMemo(() => videoTextCardColors[randInt], []);

    if (!data[selectedTab]) {
        return <Suspense />;
    }

    return (
        <div
            id="Videotextcard"
            style={{ backgroundColor: theme.primary }}
            className="text-[#3d3d3d] mt-6 md:mt-3 py-8 md:py-10 px-4 md:px-8 rounded-3xl"
        >
            {/* Top text */}
            {data[selectedTab].top ? (
                <p
                    style={{ color: theme.secondary }}
                    className="text-lg md:text-2xl font-extrabold"
                >
                    {data[selectedTab].top}
                </p>
            ) : null}

            {/* Tabs */}
            <div className="mt-4 flex overflow-x-auto gap-x-5 scrollbar-hide [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                {tabs.map((tab) => (
                    <p
                        key={tab}
                        onClick={() => setSelectedTab(tab)}
                        style={{
                            borderColor:
                                selectedTab === tab
                                    ? theme.secondary
                                    : 'transparent',
                            WebkitTapHighlightColor: 'transparent',
                        }}
                        className={`cursor-pointer whitespace-nowrap capitalize transition duration-300
                            text-sm md:text-lg font-bold select-none
                            ${selectedTab === tab ? 'border-b-4' : ''}
                            [-webkit-tap-highlight-color:transparent]
                        `}
                    >
                        {tab}
                    </p>
                ))}
            </div>

            {/* Content */}
            <div className="w-full">
                <div className="mt-8 flex flex-col md:flex-row items-center md:items-start gap-10">
                    {/* Text section */}
                    <div className="order-2 md:order-1 md:w-[45%]">
                        <p className="text-2xl md:text-4xl font-bold leading-tight">
                            {data[selectedTab].heading}
                        </p>

                        <div className="mt-4 text-sm md:text-lg font-medium leading-6 md:leading-7">
                            {data[selectedTab].body &&
                                data[selectedTab].body
                                    .split('\n')
                                    .map((i, index) => (
                                        <p key={index} className="mt-3">
                                            {i}
                                        </p>
                                    ))}

                            {data[selectedTab].points
                                ? data[selectedTab].points.map((i, idx) => (
                                      <div
                                          key={idx}
                                          className="flex items-start py-2"
                                      >
                                          <div className="mr-2">
                                              <Chip
                                                  className="px-2 rounded-full text-xs md:text-sm"
                                                  style={{
                                                      backgroundColor:
                                                          theme.secondary,
                                                  }}
                                                  value={idx + 1}
                                              />
                                          </div>
                                          <p className="text-sm md:text-lg leading-6 md:leading-7">
                                              {i}
                                          </p>
                                      </div>
                                  ))
                                : null}
                        </div>
                    </div>

                    {/* Media section */}
                    <div className="order-1 md:order-2 md:w-[55%] flex justify-center">
                        <div className="w-full max-w-[50rem] rounded-2xl shadow-xl overflow-hidden bg-white">
                            {data[selectedTab].video ? (
                                <video
                                    src={data[selectedTab].video}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className="w-full h-full aspect-video object-cover"
                                />
                            ) : data[selectedTab].image ? (
                                <Image
                                    src={data[selectedTab].image}
                                    alt={data[selectedTab].heading}
                                    width={1200}
                                    height={700}
                                    className="w-full h-auto object-cover"
                                    priority
                                />
                            ) : (
                                <video
                                    src="/images/work-order.webm"
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className="w-full h-full aspect-video object-cover"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoTextCard;
